<div *transloco="let t">
  <p-dialog [(visible)]="visible"
            [blockScroll]="false"
            [modal]="true"
            [draggable]="false"
            [style]="{width: '50vw'}"
            (onHide)="onClose.emit({ success: false });"
            appendTo="body"
  >
    <ng-template pTemplate="header">
      <span class="text-xl font-semibold">{{t('forms.confirmation')}}</span>
    </ng-template>

    <ng-template pTemplate="content">
      <div class="flex mb-3 mt-1">
        <i class="pi pi-exclamation-triangle" style="font-size: 2rem;"></i>
        <div class="ml-3 mt-2" style="color: #495057;">
          <div>
            {{'info.confirmDeleteProfile' | transloco }}
          </div>
          <div class="div mt-3">
            <p-dropdown [(ngModel)]="this.selectedProfileUuid" [placeholder]="'select.generic' | transloco"
                        [options]="profiles" [filter]="true" filterBy="name" display="chip" appendTo="body" styleClass="w-25rem"
                        optionLabel="name" optionValue="profileUuid" id="profile"></p-dropdown>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end">
        <button pButton icon="pi pi-times" [label]="'common.cancel' | transloco" (click)="this.closeDialog()"
                class="p-button-primary"></button>
        <button pButton icon="pi pi-check" [label]="'common.accept' | transloco"
                [disabled]="this.selectedProfileUuid == null" (click)="this.deleteAndReassignProfile()"
                class="p-button-danger" style="border-color: transparent"></button>
      </div>
    </ng-template>

  </p-dialog>
</div>
